<template>
    <div class="component">
        <video
            v-bind:style="{ opacity: opacity }"
            v-bind:class="{ 'd-none d-md-block': img }" muted playsinline autobuffer autoloop loop autoplay>
            <source v-bind:src="file">
        </video>

        <figure v-if="img" class="d-md-none">
            <div class="hero-bg embed-responsive-item" v-bind:style="{ 'background-image': `url(${img})` }"></div>
        </figure>
    </div>
</template>

<script>
    export default {
        name: 'background-video',
        props: ['file', 'img', 'opacity']
    }
</script>

<style lang="scss" scoped>

    .component {
        @media (max-width: 767px) {
            video {
                width: 170% !important;
                left: 50% !important;
                transform: translateX(-50%);
            }
        }

        figure {
            .hero-bg {
                background-size: cover;
                background-position: center center;
                background-repeat: no-repeat;

                opacity: .7;

                @media (min-width: 992px) {
                    background-size: cover;
                    opacity: 1;
                }
            }
        }
    }
</style>